export default __webpack_public_path__ + "static/media/organic-desktop.d773ddab.jpg";